import state from './flash.state'
import mutations from './flash.mutations'
import actions from './flash.actions'

export default {
  state,
  mutations,
  actions
}
